/* file description */
import { RefListType } from '@/asset/AssetTask/templates/Cascade/type';
import { useFreeBtnClick } from '@/components/SPTableList/effect';
import SpBusinessBtns from '@/components/sp-business-btns';
import useMetaStore from '@/store/useMetaStore';
import useValuesStore from '@/store/useValuesStore';
import { Button, Space } from 'antd';
import * as React from 'react';
import { useEffect, useState, useRef, useMemo } from 'react';

interface FormFreeButtonWarpProps {
  refList: RefListType;
  children: JSX.Element;
  moduleId: string;
  rowId?: string | number;
}

const pStyles = {
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '0px 20px',
};

const FormFreeButtonWarp: React.FC<FormFreeButtonWarpProps> = (props) => {
  const { refList, moduleId, rowId } = props;
  const { pageConfig, pageType, utils } = useMetaStore((state) => state);
  const { realoadValue, values } = useValuesStore();

  // 自定义按钮点击
  const { freeButtonClick } = useFreeBtnClick({ refList });

  const topFreeBtns = useMemo(() => {
    const extraButtonList = pageConfig?.freeBtnConfig?.filter((config: Record<string, any>) => config?.position == 'module') ?? [];
    return extraButtonList
      .filter((item) => item['position-direction'] === 'top')
      .filter((item) => item['position-module'] === moduleId);
  }, [pageConfig?.freeBtnConfig, moduleId]);

  const bottomFreeBtns = useMemo(() => {
    const extraButtonList = pageConfig?.freeBtnConfig?.filter((config: Record<string, any>) => config?.position == 'module') ?? [];
    return extraButtonList
      .filter((item) => item['position-direction'] === 'bottom')
      .filter((item) => item['position-module'] === moduleId);
  }, [pageConfig?.freeBtnConfig, moduleId]);

  const rowData = useMemo(() => {
    return values?.[moduleId]?.find((item) => item?._id === rowId) || {};
  }, [values, rowId, moduleId]);

  return (
    <>
      <p style={pStyles}>
        <SpBusinessBtns
          utils={{ ...utils, reload: realoadValue }}
          btnInfo={topFreeBtns}
          btnsClick={(value) => freeButtonClick(value, { rowData })}
        />
      </p>
      {props.children}
      <p style={pStyles}>
        <SpBusinessBtns
          utils={{ ...utils, reload: realoadValue }}
          btnInfo={bottomFreeBtns}
          btnsClick={(value) => freeButtonClick(value, { rowData })}
        />
      </p>
    </>
  );
};


export default FormFreeButtonWarp;
